import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  imports: [TranslateDirective],
})
export class InfoDialogComponent {
  protected modal = inject(NgbActiveModal);

  @Input()
  public title!: string;

  @Input()
  public text!: string;
}
